import React, {useEffect} from "react"
import _ from "lodash"
import { Checkbox } from "primereact/checkbox"
import { Listbox_s } from "styles/input-styles"

type IListBox = {
  field: string,
  data: any,
  className?: string,
  hook?: string,
  options:ListboxOption[],
  multiple: boolean,
  persist: Function,
  disabled?: boolean,
  style?:object,
  noFilter?:boolean
}

type ListboxOption = {
  label: string,
  value: string|number
}

const ListboxInput = (props: IListBox) => {

  useEffect(() => {

    const handleKeyPress = () => {
      let filters = document.querySelectorAll(".p-listbox-filter-container > input")
      _.each(filters, (filter) => {
        if(!_.includes(filter.classList, "automated")) filter.classList.add("automated")
      })
    }

    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  })

  function template(option) {
    let className = "automated listbox-checkbox"
    if(props.hook) className += ` ${props.hook}`
    return (
      <div>
        <Checkbox className={className} checked={props.data[props.field] ? props.data[props.field].includes(option.value) : false} />
        <span>{option.label}</span>
      </div>
    );
  }

  return (
    <Listbox_s
      filter={props.noFilter ? false : true}
      className={props.className}
      disabled={props.disabled || false}
      itemTemplate={template}
      value={props.data[props.field]}
      options={props.options}
      onChange={(e)=>props.persist(e.value, props.field)}
      multiple={props.multiple}
    />
  )
}

export default ListboxInput